"use strict";
var objectProto = Object.prototype;
function isPrototype(value) {
    var Ctor = value && value.constructor, proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
    return value === proto;
}
module.exports = isPrototype;
//# sourceMappingURL=_isPrototype.js.map